const GenerateScriptSkeleton = () => {
  return (
    <div className="bg-[#FDFDFD] border border-[#DDDDDD] py-3 px-[18px] rounded-lg mb-3">
      <div className="bg-white border border-[#E5E7EB] rounded-lg p-4 flex flex-col">
        {/* Hook Skeleton */}
        <div className="mb-3">
          <div className="h-5 bg-gray-200 rounded w-12 mb-1 animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded w-full mb-1 animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded w-2/3 animate-pulse"></div>
        </div>

        {/* Script Skeleton */}
        <div className="flex-1 mb-3">
          <div className="h-5 bg-gray-200 rounded w-12 animate-pulse mb-5"></div>
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
            <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenerateScriptSkeleton;
